import React from 'react';
import './BlogList.css';

// Importing necessary components and utilities
import { PageTitle, Blog, PagesNo, UniversalSidebar } from '../../../components';
import { blogContent } from '../../../constants';
import { useFilter, useFilterLoading } from '../../../utils';


const BlogList = () => {

  // Number of blog items to display per page
  const itemsPerPage = 4;

  // Fetch filtered and paginated blog data using the custom hook `useFilter`
  const {
    selectedCategory,   // Currently selected category filter
    selectedTag,        // Currently selected tag filter
    searchKeyword,      // Current search keyword
    filteredItems,      // List of blog items after applying filters
    displayedItems,     // Blog items to display on the current page
    currentPage,        // Current page number
    totalPages,         // Total number of pages
    handleSearchSubmit, // Function to handle search form submission
    handlePageChange,   // Function to handle page change in pagination
  } = useFilter(blogContent, itemsPerPage, 'blog'); // Passing 'blogs' as the type

  // Use the custom hook for loading state
  const isFiltering = useFilterLoading(filteredItems, searchKeyword);

  return (
    <>
      {/* Page title */}
      <PageTitle title={'blog list'} page={'blog list'} />

      {/* Blog list section */}
      <section className='blog list'>

        {/* Universal sidebar for filtering blogs by category, tag, or search */}
        <UniversalSidebar
          type="blog"
          selectedCategory={selectedCategory}
          selectedTag={selectedTag}
          handleSubmit={handleSearchSubmit}
        />

        {/* Blog Container (List Layout) */}
        <div className='blog-container list'>
        {isFiltering ? null : filteredItems.length === 0 ? (
            // Display message if no results are found for the search keyword
            <div className='no-found'>No Result For "{searchKeyword}".</div>
          ) : (
            // Display blog items and pagination if results are found
            <>

              {/* List of blog items */}
              {displayedItems.map((blog) => (
                <Blog key={blog.id} blog={blog} />
              ))}

              {/* Pagination */}
              <PagesNo
                currentPage={currentPage}
                totalPages={totalPages}
                handlePageChange={handlePageChange}
              />

            </>
          )}
        </div>
      </section>
    </>
  );
};

export default BlogList;
